import PropTypes from 'prop-types';
import styles from './ProgressBar.module.scss';

function ProgressBar({ progress }) {
  return (
    <div className={styles.container}>
      <div
        className={styles.progressBar}
        style={{ width: `${Math.min(100, progress / 0.94 * 100)}%` }}
      />
    </div>
  );
}

ProgressBar.propTypes = {
  progress: PropTypes.number.isRequired,
};

export default ProgressBar;
